export default __webpack_public_path__ + "static/media/ornek_toplu_giris_ve_emniyet.0c576c61.xlsx";